import { render, staticRenderFns } from "./ConfigSelectEgdsIndicazioneEdit.vue?vue&type=template&id=d06b3bd8"
import script from "./ConfigSelectEgdsIndicazioneEdit.vue?vue&type=script&lang=js"
export * from "./ConfigSelectEgdsIndicazioneEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports